import { render, staticRenderFns } from "./BaseVueTyper.vue?vue&type=template&id=7aaa0560&"
import script from "./BaseVueTyper.vue?vue&type=script&lang=js&"
export * from "./BaseVueTyper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aaa0560')) {
      api.createRecord('7aaa0560', component.options)
    } else {
      api.reload('7aaa0560', component.options)
    }
    module.hot.accept("./BaseVueTyper.vue?vue&type=template&id=7aaa0560&", function () {
      api.rerender('7aaa0560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseVueTyper.vue"
export default component.exports